import React, { useState } from 'react';
import '../CSS/style/style.css';

const RoomCarousel = ({ images, idPrefix }) => {
    const [current, setCurrent] = useState(0);

    if (!images || images.length === 0) return null;

    const prev = () => setCurrent(i => (i - 1 + images.length) % images.length);
    const next = () => setCurrent(i => (i + 1) % images.length);

    return (
        <div className="room-carousel">
            <div className="room-carousel-track">
                {images[current].type === 'video' ? (
                    <video className="room-carousel-media" autoPlay muted loop playsInline>
                        <source src={`resource/video/${images[current].src}`} type="video/mp4"/>
                    </video>
                ) : (
                    <img
                        src={`resource/img/${images[current].title}/${images[current].img}`}
                        className="room-carousel-media"
                        alt={`${images[current].title}_${images[current].seq}`}
                    />
                )}

                <span className="room-carousel-counter">{current + 1} / {images.length}</span>

                <button className="room-carousel-btn room-carousel-btn--prev" onClick={prev} aria-label="이전">&#8249;</button>
                <button className="room-carousel-btn room-carousel-btn--next" onClick={next} aria-label="다음">&#8250;</button>
            </div>

            <div className="room-carousel-dots">
                {images.map((_, idx) => (
                    <button
                        key={idx}
                        className={`room-carousel-dot${idx === current ? ' active' : ''}`}
                        onClick={() => setCurrent(idx)}
                        aria-label={`${idx + 1}번 슬라이드`}
                    />
                ))}
            </div>
        </div>
    );
};

export default RoomCarousel;
